// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ImageCarousel_imageContainer__L2qsc","image":"ImageCarousel_image__22kMS"};